import { getDynamicSemanticToken } from '../../../DesignSystem';
import { getDefaultZoomUI } from '../../../ThemeProvider';
export function getDynamicThemeToken(theme) {
    // Get dynamic semantic design token,
    // which can automatically switch between light and dark content
    const semantic = getDynamicSemanticToken(theme);
    const { typography, shadow, zIndex } = theme?.zoomUI ?? getDefaultZoomUI();
    return {
        zIndex: zIndex.Toast,
        fontFamily: typography.fontFamily,
        minHeight: '52px',
        maxWidth: '400px',
        background: semantic.fill.default,
        color: semantic.text.stronger.neutral,
        linkColor: semantic.text.primary,
        borderColor: semantic.border.subtle.neutral,
        iconColor: {
            info: semantic.icon.primary,
            success: semantic.icon.success,
            error: semantic.icon.error,
            warn: semantic.icon.warning,
        },
        boxShadow: shadow.md,
    };
}
